import React, { useCallback, useEffect, useRef } from 'react';
import { ArrowBack, Search } from '@yme/assets/icons';
import { ControlPanel, InputStyled } from '@yme/atoms/filters-elements/SearchInput';
import { useTranslation } from '@yme/services/i18n';
import { SEARCH_DATA_TEST_ID, SEARCH_FIELD_NAME, MAX_SYMBOLS_TO_SEARCH } from './constants';
import { BackButtonStyled, HiddenButtonStyled, InputWrapperStyled } from './styled';
export function SearchInput(props) {
    const { isRightToLeft = false, isDisabled = false, inputValue = '', setInputValue, onFocusHandler, onSearchCloseHandler, onKeyDownHandler, className, isOpen, isMobile, backgroundColor, focusable, } = props;
    const { t } = useTranslation();
    const inputRef = useRef(null);
    useEffect(() => {
        if (inputRef.current && focusable) {
            inputRef.current?.focus();
        }
    }, [focusable]);
    const onClear = useCallback(() => {
        setInputValue('');
    }, [setInputValue]);
    const ClearButton = (React.createElement(ControlPanel, { onClick: onClear, isRightToLeft: isRightToLeft, isVisible: Boolean(inputValue) }));
    return (React.createElement(InputWrapperStyled, null,
        React.createElement(InputStyled, { type: "text", placeholder: t('globalSearch_searchBar_placeholder'), ref: inputRef, name: SEARCH_FIELD_NAME, id: SEARCH_FIELD_NAME, leftIcon: isOpen && isMobile ? ArrowBack : Search, changeHandler: setInputValue, dataTestId: SEARCH_DATA_TEST_ID, value: inputValue, isRightToLeft: isRightToLeft, focusHandler: onFocusHandler, onKeyDownHandler: onKeyDownHandler, isDisabled: isDisabled, className: className, multipleIconsBlock: ClearButton, backgroundColor: backgroundColor, maxLength: MAX_SYMBOLS_TO_SEARCH, hasFilters: true, focusable: focusable }),
        isOpen && isMobile && (React.createElement(BackButtonStyled, { onClick: onSearchCloseHandler },
            React.createElement(HiddenButtonStyled, null)))));
}
SearchInput.displayName = 'SearchInput_Atom';
